import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.palette.primary.main,
  },
}));